import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { useUserStore } from './store/userData'
import { useCompaniesStore } from './store/companyStatic'
import router from './router'
import './assets/styleclasses.css'
import { fpjsPlugin } from '@fingerprintjs/fingerprintjs-pro-vue-v3';

async function startApp() {
  const app = createApp(App)
  const pinia = createPinia()
  app.use(pinia)
  app.use(fpjsPlugin, {
    loadOptions: {
      apiKey: "LTDeSiLeGSUGbSoaR4fQ",
      region: "eu"
    },
  })

  const userStore = useUserStore()
  await userStore.hydrateState()

  const companiesStore = useCompaniesStore()
  if (userStore.isLoggedIn) {
    companiesStore.hydrateStorage()
  
    try {
      await companiesStore.fetchPreferences()
      companiesStore.fetchCatalog()
    } catch (error) {
      console.error('Failed to load preferences:', error)
    }
  }  

  app.use(router)
  app.mount('#app')
}

startApp()